<div class="app-page">

  @for (p of this._flowitems; track p) {
    <div>
      {{p.PlayerView.LastName + ", " + p.PlayerView.FirstName }}
    </div>
  }


</div>
